import { Ban } from 'lucide-react'
import type { BlockedTaskVM } from '../utils/incidentSelectors'

interface BlockedTasksProps {
  tasks: BlockedTaskVM[]
}

export function BlockedTasks({ tasks }: BlockedTasksProps): JSX.Element {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4">
      <div className="mb-3 flex items-center gap-2">
        <Ban className="h-5 w-5 text-amber-500" />
        <h3 className="text-base font-semibold text-gray-900">Blocked Tasks</h3>
      </div>
      {tasks.length === 0 ? (
        <p className="py-6 text-center text-sm text-gray-400">No blocked tasks.</p>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs text-gray-400">
              <th className="pb-2 font-medium">Task</th>
              <th className="pb-2 font-medium">Reason</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {tasks.map((task) => (
              <tr key={task.id}>
                <td className="py-2 font-medium text-gray-900">{task.title}</td>
                <td className="py-2">
                  <span className="rounded bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-600">{task.reason}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
